import request from '@/config/request.js'
const ApiRenewal = request.Renewal
const ApiClassManagement = request.ClassManagement

import tools from '@/util/tools'
const basic = tools.basic
export default {
  props: [],
  data() {
    return {
      loading: false,
      visible: false,
      isDetail: false,
      dataForm: {
        id: '',
        studyClassIds: [],
        renewalCounts: [],
        templateRenewRate: '',
        renewYear: '2025',
        targetType: '春季续费'
      },
      tableList: [],
      selectedRows: [],
      classList: [],
      selectionLocked: false
    }
  },

  watch: {},
  mounted() {},
  methods: {
    getClassList () {
      var data = {}
      data = Object.assign(data, { studyClassCondition: 'CLASS_MANAGEMENT', studyClassType: 'HOSTING' })
      ApiClassManagement.getClassList.call(this, data, (listData) => {
        this.tableList = listData.map(item => {
          return {
            ...item,
            studyClass: {
              ...item.studyClass,
            classDegrees: item.studyClass?.classDegrees ? item.studyClass.classDegrees : 0,
            renewalCount: item.studyClass?.classDegrees ? item.studyClass.classDegrees : 0
            },
            
          }
        })
      })
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    updateSelectionPayload() {
      const list = Array.isArray(this.selectedRows) ? this.selectedRows : []
      
      this.dataForm.studyClassIds = list.map(item => item.studyClass.studyClassId)
      this.dataForm.renewalCounts = list.map(item => item.studyClass.renewalCount)
      const totalCount = list.reduce((s, r) => s + (Number(r.studyClass.classDegrees) || 0), 0)
      const totalRenew = list.reduce((s, r) => s + (Number(r.studyClass.renewalCount) || 0), 0)
      this.dataForm.templateRenewRate = totalCount ? Math.round((totalRenew / totalCount) * 100) : 0
    },
    
    onRenewCountChange(row) {
      if (!row || !row.studyClass) return
      const max = Number(row.studyClass.classDegrees) || 0
      if (row.studyClass.renewalCount > max) row.studyClass.renewalCount = max
      if (row.studyClass.renewalCount < 0) row.studyClass.renewalCount = 0
      this.updateSelectionPayload()
    },
    clampRenew(index) {
      const row = this.tableList[index]
      if (!row) return
      const max = Number(row.count) || 0
      if (row.renewalCount > max) row.renewalCount = max
      if (row.renewalCount < 0) row.renewalCount = 0
    },
    init(row) {
      this.visible = true
      this.selectionLocked = false
      this.dataForm = {
        id: '',
        studyClassIds: [],
        renewalCounts: [],
        templateRenewRate: '',
        renewYear: '2025',
        targetType: '春季续费'
      }
      if (row && row.length > 0) {
        this.tableList = row.map(item => {
          return {
            ...item,
            studyClass: {
              ...item.studyClass,
            classDegrees: item.studyClass?.classDegrees ? item.studyClass.classDegrees : 0,
            renewalCount: item.renewalCount || 0
            },
            
          }
        })
        this.dataForm = basic.partData(row[0], [
          {'id': {  id: (row[0].id ) }},
          {'renewYear': {renewYear: (row[0].renewYear + '') }},
          'targetType', 
          'templateRenewRate',
        ])

         this.$nextTick(() => {
          this.$refs.renewTable.clearSelection()
          this.$refs.renewTable.toggleAllSelection(true)
          this.selectionLocked = true
         })
        
      } else {
       this.getClassList()
      }
      
     

    },
    dataFormSubmit() {
      this.$refs['elForm'].validate(valid => {
        if (valid) {
          this.updateSelectionPayload()
          let urlApi = this.dataForm.id ? 'updateBatch' : 'addBatch'
          let data  = {}
          if (!this.dataForm.studyClassIds || this.dataForm.studyClassIds.length === 0) {
            this.$message({
              message: '请选择班级',
              type: 'error'
            })
            return
          }
          if (this.dataForm.id) {
            data = {
              ...this.dataForm,
              studyClass: {
                studyClassId: this.dataForm.studyClassIds[0]
              },
              renewalCount: this.dataForm.renewalCounts[0]
            }
            delete data.studyClassIds
            delete data.renewalCounts
          } else {
            data = {
              ...this.dataForm
            }
          }
          ApiRenewal[urlApi].call(this, data, (res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.visible = false
            this.$emit('refresh')
          }), false, err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
        }
      })
    }
  }
}
